// @ts-nocheck


import React, { useEffect, useState } from 'react';

import Modal from '../../../../../components/ant/Modal';

import find from 'lodash/find';
import sortBy from 'lodash/sortBy';


import { fuelTypes } from '../../../../../lib/enum';
import { plus } from '../../../../../lib/helpers';

import { AntTable } from '../../../../../components/ui';



export const ModalFuelAndOilCalculation = (
props) =>



{
  const { visible, data, itogData, monthIndex = 0, handleCancel } = props;
  const columns = [
  {
    title: 'Наименование',
    dataIndex: 'name'
  },
  {
    title: 'Количество, л',
    dataIndex: 'count'
  },
  {
    title: 'Стоимость',
    dataIndex: 'cost'
  }];

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const findAndAdd = (sum, { name, count = 0, cost = 0 }) => {
      if (!name) return;

      let obj = find(sum, ['name', name]);
      if (obj) {
        obj.count = plus(obj.count, count);
        obj.cost = plus(obj.cost, cost);
      } else {
        sum.push({
          name: name,
          count: count,
          cost: cost
        });
      }
    };

    if (itogData) {
      const listData = itogData.reduce(
        (sum, record) => {
          if (record?.months[monthIndex].fuel?.type)
          findAndAdd(sum, {
            name: fuelTypes[record.months[monthIndex].fuel.type],
            count: record.months[monthIndex].fuel.count,
            cost: record.months[monthIndex].fuel.cost
          });
          // eslint-disable-next-line no-unused-expressions
          record?.months[monthIndex].oils?.forEach((el) => {
            findAndAdd(sum, {
              name: fuelTypes[el.type],
              count: el.count,
              cost: el.cost
            });
          });
          return sum;
        },
        []
      );
      setTableData(
        sortBy(listData, (el) => Object.values(fuelTypes).indexOf(el.name))
      );
    } else if (data) {
      setTableData([
      {
        name: data.months[monthIndex]?.fuel?.type ?
        fuelTypes[data.months[monthIndex].fuel.type] :
        '-',
        count: data.months[monthIndex]?.fuel?.count || 0,
        cost: data.months[monthIndex]?.fuel?.cost || 0
      },
      ...(data.months[monthIndex]?.oils?.map((el) => {
        return {
          name: fuelTypes[el.type],
          count: el.count,
          cost: el.cost
        };
      }) ?? [])]
      );
    }
  }, [data, itogData, monthIndex]);

  return (
    <Modal
      destroyOnHidden
      width={600}
      title="Полное описание"
      visible={visible}
      footer={null}
      onCancel={handleCancel}>

      <AntTable columns={columns} data={tableData} pagination={false} />
    </Modal>);

};
